<template>
  <v-app class="grey lighten-4">
    <Snackbar />
    <Navbar />
    <v-content
      :class="{
        'mx-0 mb-1': $vuetify.breakpoint.smAndDown,
        'mx-2 mb-2': $vuetify.breakpoint.mdAndUp
      }"
    >
      <div v-if="accountNeedsAttention">
        <v-alert
          :value="true"
          :dismissible="true"
          color="error"
          transition="scale-transition"
          icon="info"
          class="ma-3"
        >
          <span
            >Your account requires attention as it's status is
            {{ this.account.status }} &nbsp;&nbsp;</span
          >
        </v-alert>
      </div>
      <div v-if="accountExpired">
        <v-alert
          :value="showAccountAttention"
          :dismissible="true"
          color="warning"
          transition="scale-transition"
          icon="info"
          class="ma-3"
        >
          <span
            >Your account has expired. To resume normal service you'll need to
            upgrade.</span
          >
        </v-alert>
      </div>
      <div v-if="accountExpires">
        <v-alert
          :value="showAccountAlert"
          :dismissible="true"
          color="success"
          outline
          transition="scale-transition"
          icon="info"
          class="ma-3"
        >
          <span
            >Your trial account is expiring shortly ({{ expiresDate }}). Why not
            take a moment to check out your upgrade options? &nbsp;&nbsp;</span
          >
          <v-btn right flat text small @click="gotoBilling"
            >Upgrade Options</v-btn
          >
        </v-alert>
      </div>
      <div v-if="loggedIn">
        <v-alert
          :value="showVerifiedAlert"
          :dismissible="showVerifiedAlert"
          color="info"
          transition="scale-transition"
          icon="info"
          class="ma-3"
        >
          <span>Your email address needs to be verified: &nbsp;&nbsp;</span>
          <v-btn right flat text small @click="verifyEmail"
            >Begin Email Verification</v-btn
          >
        </v-alert>
      </div>
      <router-view :key="$route.fullPath" />
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Navbar from './components/NavBar';
import Snackbar from './components/Snackbar';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(LocalizedFormat);

export default {
  name: 'App',
  components: { Navbar, Snackbar },
  data: function() {
    return {
      showAccountAttention: true,
      showAccountAlert: true,
      showVerifiedAlert: false
    };
  },
  computed: {
    ...mapState('auth', ['account', 'isVerified']),
    ...mapGetters('auth', ['loggedIn', 'userId', 'isTeamOwner']),
    accountNeedsAttention() {
      if (this.account) {
        if (
          this.account.status !== 'ACTIVE' &&
          this.account.status !== 'FREE' &&
          this.account.status !== 'TRIAL' &&
          this.account.status !== 'EXPIRED'
        ) {
          return true;
        }
      }
      return false;
    },
    accountExpired() {
      return this.account && this.account.status === 'EXPIRED';
    },
    accountExpires() {
      return this.account && this.account.status === 'TRIAL';
    },
    expiresDate() {
      if (this.account) {
        return dayjs.utc(this.account.expires).format('ll');
        //return dayjs.utc(this.account.expires).fromNow();
      }
      return '';
    }
  },
  watch: {
    isVerified: function(newValue) {
      this.showVerifiedAlert = !newValue;
    }
  },
  mounted: function() {
    this.showVerifiedAlert = !this.isVerified;
  },
  methods: {
    ...mapActions({
      sendVerification: 'account/sendVerificationEmail',
      setSnack: 'snackbar/setSnack'
    }),
    gotoBilling() {
      this.showAccountAlert = false;
      this.$router.push('/billing');
    },
    async verifyEmail() {
      if (this.userId) {
        this.showVerifiedAlert = false;
        await this.sendVerification({
          userId: this.userId
        });
        this.setSnack('Verifications instructions sent to your email');
      }
    }
  }
};
</script>
